// NPM
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { omitBy, isNull, map, find } from "lodash";
import errorHandler from "Utils/error-handler";

// ANT COMPONENTS
import { Input } from "antd";
import { AlertBox, Button, SelectInput } from "@life-line-lab/components-react";

// SCHEMAS
import { ParcelsOrderRejectFlagSchema, ParcelsOrderCancelSchema } from "./flag-reject-parcel-validation";

// SERVICES
import { fetchGoodsCareConditionList } from "Services/order.service";

interface FlagRejectParcelModalProps {
    orderID?: any;
    action: string;
    onSubmit?: any;
    onCancel?: any;
    customer?: any;
}

const FlagRejectParcelModal: React.FC<FlagRejectParcelModalProps> = ({
    action,
    orderID,
    onSubmit,
    onCancel,
    customer
}) => {
    const { t } = useTranslation();

    const initialInput = {
        orderID: orderID ? orderID : "",
        issueType: "",
        remarks: "",
        label: ""
    };

    const initialError = {};
    const [input, setInput] = useState(initialInput);
    const [error, setError] = useState<any>(initialError);
    const [issueTypeOptions, setIssueTypeOptions] = useState<any>([])
    const [selectedRemarks, setSelectedRemarks] = useState<any>(input.remarks);
    const [selectedName, setSelectedName] = useState<any>(input.label);

    useEffect(() => {
        handleIssueTypeFetch()
    }, []);

    useEffect(() => {
        setInput({ ...input, remarks: selectedRemarks, label: selectedName })
    }, [selectedRemarks])

    const handleFieldChange = (e) => {
        setError(initialError)
        setInput({ ...input, [e.target.name]: e.target.value })
    }

    const handleSelectChange = (value: string | string[] | {}, name: string) => {
        setError(initialError);
        setInput({ ...input, [name]: value });
        let label = (find(issueTypeOptions, (issue) => issue.id == value) || {}).name
        setSelectedName(label)
        let remark = (find(issueTypeOptions, (issue) => issue.id == value) || {}).remark;
        setSelectedRemarks(remark);
    };

    const handleIssueTypeFetch = async () => {
        let orderSettingTypes = 'ISSUE_TYPE'
        const responseData = await fetchGoodsCareConditionList(customer._id, [orderSettingTypes])
        map(responseData, (issue) => {
            map(issue, (subOptions) => {
                setIssueTypeOptions(subOptions)
            })
        })
    }

    const handleSubmit = () => {
        try {
            const valInput = action != 'CANCEL'
                ? {
                    issueType: {
                        id: input.issueType,
                        name: input.label,
                        remarks: input.remarks,
                    },
                    orderID: input.orderID,
                } : {
                    orderID: input.orderID,
                    remarks: input.remarks,
                }
            const value = action != 'CANCEL' ? ParcelsOrderRejectFlagSchema.validateSync(omitBy(valInput, isNull), {
                strict: false,
                abortEarly: true,
                stripUnknown: true,
            }) : ParcelsOrderCancelSchema.validateSync(omitBy(valInput, isNull), {
                strict: false,
                abortEarly: true,
                stripUnknown: true,
            })
            onSubmit(value);
            onCancel();
        } catch (err) {
            console.log(err);
            const { path, value }: any = errorHandler.validation(err);
            setError({ ...error, [path]: t(`${value}`, { field: t(`label.${path}`) }) });
        }
    };

    return (
        <>
            <div className="modal-content-title">
                {t(action == "REJECT"
                    ? "label.rejectParcel"
                    : action == "CANCEL"
                        ? "label.cancelParcel"
                        : "label.flagParcel")
                    .toLocaleUpperCase()}
            </div>

            <div className='modal-content-text'>
                <span className='bold'>{t("label.sender").toLocaleUpperCase()}: </span>
                <span>{customer?.name || customer?.fullName}</span>
            </div>

            <div className='modal-content-text'>
                {action != 'CANCEL' && <div>
                    <SelectInput
                        showSearch
                        options={map(issueTypeOptions, (issue) => {
                            return {
                                label: issue?.name,
                                value: issue?.id,
                            }
                        })}
                        name="issueType"
                        placeholder={t("placeholder.specialConditions")}
                        label={t("label.selectIssueCategory")}
                        isRequired={true}
                        onChange={(value) => handleSelectChange(value, "issueType")}
                    />
                    <AlertBox text={error.issueType} />
                    <br />
                </div>}

                <label className="inp-label" >{t("label.remarks")}</label>
                <Input.TextArea
                    size="middle"
                    autoSize={{ minRows: 5, maxRows: 6 }}
                    name="remarks"
                    required={true}
                    placeholder={t("txt.enterHere")}
                    value={input.remarks}
                    onChange={handleFieldChange}
                />
                <br />
            </div>

            <div className="mt-30 right modal-end-button">
                <Button
                    type={action == "REJECT" ? 'danger' : 'primary'}
                    label={t(action == "REJECT" ? "action.reject" : "action.confirm")}
                    onClick={() => { handleSubmit() }}
                />
                <Button
                    className={action == "REJECT" ? "cancel-btn-reject-order" : 'cancel-btn'}
                    type={'default'}
                    label={t("action.cancel")}
                    onClick={() => { onCancel() }}
                />
            </div>
        </>
    )
};

export default FlagRejectParcelModal;